import type { TFunction } from 'i18next';

import type { PlanningCycleStatus } from '../types/consensus.types';

export function planningCycleStatusLabel(status: string, t: TFunction): string {
  const key = `consensus.cycleStatus.${status}`;
  const translated = t(key);
  return translated === key ? status : translated;
}

export function cycleStatusBadgeClass(status: PlanningCycleStatus): string {
  switch (status) {
    case 'approved':
      return 'bg-green-100 text-green-800';
    case 'open':
    case 'in_review':
      return 'bg-blue-100 text-blue-800';
    case 'closed':
      return 'bg-gray-100 text-gray-700';
    case 'cancelled':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-amber-100 text-amber-800';
  }
}
